import { Heading } from '@efdigital/ll-addon-ui';
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import { hash } from '@ember/helper';
import { LinkTo } from '@ember/routing';

interface LibraryFoldersFileModel {
  file: {
    id: string;
    name: string;
    parent: string;
    title?: string;
    description?: string;
    contentType?: string;
  };
}

const LibraryFoldersFile: TemplateOnlyComponent<{
  Args: { model: LibraryFoldersFileModel };
}> = <template>
  <div class="container py-5">
    <Heading @text="File Details">
      <LinkTo
        @route="library.folders.index"
        @query={{hash parent=@model.file.parent}}
        class="btn btn-sm btn-outline-secondary"
      >
        <iconify-icon inline icon="ph:arrow-left" />
        Back to Folders
      </LinkTo>
    </Heading>

    <div class="card">
      <div class="card-body">
        <h5 class="mb-3">Identifier</h5>
        <div class="row mb-3">
          <div class="col-md-6">
            <label class="form-label" for="file-name">Name</label>
            <input
              type="text"
              class="form-control"
              id="file-name"
              value={{@model.file.name}}
              readonly
              disabled
            />
          </div>
          <div class="col-md-6">
            <label class="form-label" for="file-content-type">Content Type</label>
            <input
              type="text"
              class="form-control"
              id="file-content-type"
              value={{@model.file.contentType}}
              readonly
              disabled
            />
          </div>
        </div>

        <div class="mb-3">
          <label class="form-label" for="file-id">Unique ID</label>
          <input
            type="text"
            class="form-control"
            id="file-id"
            value={{@model.file.id}}
            readonly
            disabled
          />
        </div>

        <hr />

        <h5 class="mb-3">Metadata</h5>
        <div class="mb-3">
          <label class="form-label" for="file-title">Title</label>
          <input
            type="text"
            class="form-control"
            id="file-title"
            value={{@model.file.title}}
            readonly
            disabled
          />
        </div>

        <div class="mb-3">
          <label class="form-label" for="file-description">Description</label>
          <input
            type="text"
            class="form-control"
            id="file-description"
            value={{@model.file.description}}
            readonly
            disabled
          />
        </div>
      </div>
    </div>
  </div>
</template>;

export default LibraryFoldersFile;
